// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.103.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.103.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Measurement tooltip styles */
.drawer-tooltip {
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  color: white;
  padding: 4px 8px;
  opacity: 0.7;
  white-space: nowrap;
  font-size: 12px;
  cursor: default;
  user-select: none;
}

.drawer-tooltip-measure {
  opacity: 1;
  font-weight: bold;
}

.drawer-tooltip-measure:before {
  border-top: 6px solid rgba(0, 0, 0, 0.5);
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  content: '';
  position: absolute;
  bottom: -6px;
  margin-left: -7px;
  left: 50%;
}
`, "",{"version":3,"sources":["webpack://./../geoview-drawer/src/measurement-styles.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,SAAS;AACX","sourcesContent":["/* Measurement tooltip styles */\n.drawer-tooltip {\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 4px;\n  color: white;\n  padding: 4px 8px;\n  opacity: 0.7;\n  white-space: nowrap;\n  font-size: 12px;\n  cursor: default;\n  user-select: none;\n}\n\n.drawer-tooltip-measure {\n  opacity: 1;\n  font-weight: bold;\n}\n\n.drawer-tooltip-measure:before {\n  border-top: 6px solid rgba(0, 0, 0, 0.5);\n  border-right: 6px solid transparent;\n  border-left: 6px solid transparent;\n  content: '';\n  position: absolute;\n  bottom: -6px;\n  margin-left: -7px;\n  left: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
